import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import OutlinedInput from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/OutlinedInput';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  onChangeInput,
  onInputKeyDown,
  onInputKeyUp,
  onOpenResults,
  useSearchBarDispatch,
  useSearchBarState,
} from 'Components/AdvisorApp/Header/ClientSearchBar/BetaSearchBar/SearchBarContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import TooltipTitle from 'Components/AdvisorApp/Header/ClientSearchBar/BetaSearchBar/SearchInput/TooltipTitle';
import StartAdornment from './StartAdornment';

const styles = (theme) => ({
  root: {
    maxWidth: theme.dimensions.md,
    margin: theme.spacing(0, 3),
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    '&.Mui-focused > .MuiOutlinedInput-notchedOutline': {
      borderWidth: 1,
      borderColor: theme.palette.facet.muiMediumGray,
    },
  },
  adornedStart: {
    paddingLeft: theme.spacing(0.75),
  },
  input: {
    padding: theme.spacing(1),
  },
  notchedOutline: {
    borderRadius: theme.radius.md,
  },
  tooltipPopper: {},
  tooltipArrow: {},
  hidden: {
    display: 'none',
  },
  tooltipTitle: {},
});

const SearchInput = ({
  className,
  classes,
  inputRef,
}) => {
  const eventTracking = useEventTrackingLogEvent();
  const searchBarDispatch = useSearchBarDispatch();
  const searchBarState = useSearchBarState();
  const { searchTerm } = useSearchBarState();
  return (
    <Tooltip
      arrow
      classes={{
        popper: classNames(classes.tooltipPopper, {
          [classes.hidden]: searchBarState.searchResultsOpen,
        }),
        arrow: classNames(classes.tooltipArrow, {
          [classes.hidden]: searchBarState.searchResultsOpen,
        }),
      }}
      disableFocusListener
      title={
        <TooltipTitle
          className={classes.tooltipTitle}
        />
      }
    >
      <OutlinedInput
        classes={{
          root: classNames(classes.root, className),
          input: classes.input,
          adornedStart: classes.adornedStart,
          notchedOutline: classes.notchedOutline,
        }}
        ref={inputRef}
        inputProps={{
          id: 'global-search-input',
          tabIndex: 1,
          autoComplete: 'off',
          autoCorrect: 'false',
          spellCheck: 'false',
        }}

        onKeyDown={onInputKeyDown(searchBarDispatch, searchBarState, eventTracking)}
        onKeyUp={onInputKeyUp()}
        onClick={onOpenResults(searchBarDispatch, searchBarState, eventTracking)}
        onChange={onChangeInput(searchBarDispatch, searchBarState, eventTracking)}
        placeholder={'Search...'}
        startAdornment={<StartAdornment />}
        test={'global-search-box'}
        value={searchTerm}
      />
    </Tooltip>
  );
};

SearchInput.defaultProps = {
  className: '',
};

SearchInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  inputRef: PropTypes.object.isRequired,
};

export default withStyles(styles)(SearchInput);
